import { useContext, useMemo } from 'react';

import { CookiesContext } from 'hooks/cookiesContext';
import Cookies from 'universal-cookie';

export const useCookies = () => {
    const cookiesContext = useContext(CookiesContext);
    return useMemo(() => (cookiesContext ? new Cookies(cookiesContext) : new Cookies()), [cookiesContext]);
};
